import { formatCurrency } from '@erp/shared-utils';
import type { BuyingOrderRow } from '@erp/rpc';

export interface OrderSummaryLabels {
  kind: (kind: BuyingOrderRow['kind']) => string;
  lines: (count: number) => string;
  locations: (count: number) => string;
}

/**
 * The one-line stand-in for a folded Orders section:
 * `PO · Valley Growers → GL2 · 3 lines · $85,818.30`, or the location count
 * in place of the ship-to for a vendor row.
 */
export function orderSummary(
  row: BuyingOrderRow,
  labels: OrderSummaryLabels,
): string {
  const owner =
    row.kind === 'to'
      ? (row.sourceWarehouseName ?? '')
      : (row.supplierName ?? '');
  const target =
    row.shipToWarehouseId === null
      ? labels.locations(row.locationCount)
      : (row.shipToWarehouseCode ?? row.shipToWarehouseName ?? '');
  const name =
    row.shipToWarehouseId === null
      ? `${owner} · ${target}`
      : `${owner} → ${target}`;
  return [
    labels.kind(row.kind),
    name,
    labels.lines(row.lineCount),
    formatCurrency(row.cartTotal),
  ].join(' · ');
}
